<template>
	<div class="hot-exhibition">
		<!-- 板块标题 -->
		<div class="section-title">
			<div class="section-title_left hot-exhibition-title">
				<h3>热门展销</h3>
			</div>
			<router-link to="/mallStore" target="_blank" class="section-title_more">
				<span>更多+</span>
			</router-link>
		</div>

		<!-- 卡片列表：n * 4 排版 -->
		<div class="goods-card-list">
			<mall-goods-card
				v-for="(item, index) in goodsList"
				:key="index"
				:goods-id="item.goodsId"
				:image="item.image"
				:title="item.title"
				:price="item.price"
				:sold-count="item.soldCount"
				:contact-phone="item.contactPhone"
				:click-count="item.clickCount"
				:location-fn="() => handleCardClick(item)"
			/>
		</div>
	</div>
</template>

<script>
	import MallGoodsCard from '@/components/MallGoodsCard'

	/**
	 * @description 商城首页-热门展销板块
	 */
	export default {
		name: 'HotExhibition',
		components: {
			MallGoodsCard
		},
		props: {},
		data() {
			return {
				// 示例数据，后期可替换为接口数据
				goodsList: [
					// {
					// 	goodsId: '1',
					// 	image: require('@/assets/mall/goods/goods-signature.png'),
					// 	title: '电子签章',
					// 	price: '400元/年',
					// 	soldCount: 428,
					// 	clickCount: 6243345,
					// 	path: '/mallStore/goods-signature/'
					// },
					{
						goodsId: '2',
						image: require('@/assets/mall/goods/goods-propaganda.png'),
						title: '企业宣传投放',
						price: '1.5w-5w',
						soldCount: 2659,
						clickCount: 6243345,
						path: '/mallStore/goods-propaganda/'
					},
					{
						goodsId: '3',
						image: require('@/assets/mall/goods/goods-corporate.png'),
						title: '企业风采投放',
						price: '1.5w-5w',
						soldCount: 1375,
						clickCount: 6243345,
						path: '/mallStore/goods-corporate/'
					},
					{
						goodsId: '4',
						image: require('@/assets/mall/goods/goods-customized.png'),
						title: '企业风采与宣传定制服务',
						price: '面议',
						contactPhone: '1859234781',
						clickCount: 6243345,
						path: '/mallStore/goods-customized/'
					}
				]
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			handleCardClick(item) {
				this.$router.push({
					path: item.path + item.goodsId
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hot-exhibition {
		width: $main-page-width;
		margin: 30px auto 0;

		// 标题图标：使用雪碧图，每个图标 32*32
		// 坐标需根据实际雪碧图资源调整，当前为占位坐标
		.hot-exhibition-title::before {
			background-image: url('~@/assets/icons.png');
			background-position: -96px -32px;
			background-repeat: no-repeat;
		}

		// 卡片列表：4列网格布局
		.goods-card-list {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			gap: 20px;
			padding: 20px;
			background: #fff;
			border-radius: 8px;
			box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);
		}
	}
</style>
